import { useEffect, useState } from "react";

export default function Footer() {
  const [year] = useState(new Date().getFullYear());
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      <footer className="bg-accent-900 text-accent-50">
        <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
          <div className="grid gap-10 md:grid-cols-4">
            <div className="md:col-span-2">
              <a href="#top" className="flex items-center gap-2">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-xl text-accent-700">
                  <i className="ri-seedling-line"></i>
                </span>
                <span className="font-display text-2xl text-background-50">
                  吃瓜<span className="text-secondary-300">52</span>
                </span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-accent-100/80">
                吃瓜52是我爱吃瓜人群的日常打卡与在线等瓜聚集地。每天看看今天看什么、蹲一个后续、
                在线等瓜，围观群众实时更新线索，把热门事件脉络整理得清清楚楚。
              </p>
              <div className="mt-5 flex gap-2">
                {[
                  { icon: "ri-question-answer-line", label: "微信" },
                  { icon: "ri-share-forward-line", label: "微博" },
                  { icon: "ri-book-open-line", label: "豆瓣" },
                  { icon: "ri-video-line", label: "哔哩哔哩" },
                  { icon: "ri-mail-line", label: "邮箱" },
                ].map((s) => (
                  <a
                    key={s.label}
                    href="#subscribe"
                    aria-label={s.label}
                    className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-800 text-accent-100 transition-colors hover:bg-secondary-500 hover:text-background-50"
                  >
                    <i className={`${s.icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-display text-base text-background-50">快速吃瓜</h4>
              <ul className="mt-4 flex flex-col gap-3 text-sm">
                {[
                  { label: "今日热瓜", href: "#hot" },
                  { label: "吃瓜热榜", href: "#rank" },
                  { label: "蹲后续", href: "#follow" },
                  { label: "吃瓜频道", href: "#channels" },
                ].map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-accent-100/80 transition-colors hover:text-secondary-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-display text-base text-background-50">帮助与联系</h4>
              <ul className="mt-4 flex flex-col gap-3 text-sm">
                {[
                  { label: "群众口碑", href: "#reviews" },
                  { label: "常见问题", href: "#faq" },
                  { label: "订阅吃瓜", href: "#subscribe" },
                  { label: "联系我们", href: "#faq" },
                ].map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-accent-100/80 transition-colors hover:text-secondary-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
              <p className="mt-5 flex items-center gap-2 text-sm text-accent-100/70">
                <i className="ri-mail-line"></i>
                hello@chigua52.com
              </p>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-3 border-t border-accent-800 pt-6 text-xs text-accent-100/70 sm:flex-row sm:items-center sm:justify-between">
            <p>© {year} 吃瓜52 · 我爱吃瓜日常打卡社区。理性吃瓜，文明围观。</p>
            <p className="flex items-center gap-2">
              <i className="ri-plant-line text-secondary-300"></i>
              做一个有分寸的吃瓜群众
            </p>
          </div>
        </div>
      </footer>

      <button
        type="button"
        onClick={scrollTop}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
          show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line"></i>
      </button>
    </>
  );
}